// components/OfficeAddress.jsx
import React from "react";
import "./OfficeAddress.css";

// Import social media icons
import FacebookIcon from "../assets/images/fb-icon.png";
import InstagramIcon from "../assets/images/insta-icon.png";
import TiktokIcon from "../assets/images/tiktok-icon.png";

const OfficeAddress = () => {
  const contactInfo = [
    {
      id: 1,
      icon: "📞",
      title: "Phone",
      content: "+92-317-0725045",
      link: "tel:+923170725045",
      type: "phone",
    },
    {
      id: 2,
      icon: "✉️",
      title: "Email",
      content: "ceo@teckpik.com",
      link: "mailto:ceo@teckpik.com",
      type: "email",
    },
    {
      id: 3,
      icon: "📍",
      title: "Address",
      content: (
        <>
          Teckpik, 3rd Floor Pacific Center
          <br />
          F-8 Markaz, Islamabad
          <br />
          Pakistan
        </>
      ),
      type: "text",
    },
    {
      id: 4,
      icon: "🕒",
      title: "Business Hours",
      content: (
        <>
          Monday - Friday: 9:00 AM - 6:00 PM
          <br />
          Saturday: 10:00 AM - 2:00 PM
          <br />
          Sunday: Closed
        </>
      ),
      type: "text",
    },
  ];

  const socialLinks = [
    {
      id: 1,
      icon: FacebookIcon,
      alt: "Facebook",
      url: "https://facebook.com/teckpik",
    },
    {
      id: 2,
      icon: InstagramIcon,
      alt: "Instagram",
      url: "https://instagram.com/teckpik",
    },
    {
      id: 3,
      icon: TiktokIcon,
      alt: "TikTok",
      url: "https://tiktok.com/@teckpik1",
    },
  ];

  return (
    <div className="office-address">
      <h2 className="info-title fw-bold">Contact Information</h2>
      <p className="info-subtitle">
        Feel free to reach out to us through any of these channels
      </p>

      <div className="contact-details">
        {contactInfo.map((item) => (
          <div key={item.id} className="contact-item">
            <div className="contact-icon">
              <span className="icon-emoji">{item.icon}</span>
            </div>
            <div className="contact-content">
              <h4 className="contact-item-title">{item.title}</h4>
              {item.type === "text" ? (
                <div className="contact-text">{item.content}</div>
              ) : (
                <a href={item.link} className="contact-link contact-text">
                  {item.content}
                </a>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Social Media */}
      <div className="social-section">
        <h4 className="social-title">Follow Us</h4>
        <div className="social-links">
          {socialLinks.map((social) => (
            <a
              key={social.id}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
            >
              <img src={social.icon} alt={social.alt} className="social-icon" />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OfficeAddress;
